/**
 * useViewMode Hook — DEPRECATED, always returns "list".
 *
 * Tools used to offer a card/list toggle. The card rendering was broken in most
 * places (cards collapsed to a top border with no height), it meant maintaining
 * two presentations of every table, and no view showed anything the table
 * didn't — every call site already defined full `columns`. Card view has
 * therefore been dropped app-wide.
 *
 * This is kept as a no-op rather than deleted so any lingering caller keeps
 * working, and — importantly — so a previously persisted "cards" value can no
 * longer put someone into a view with no toggle left to escape it.
 *
 * @returns {[string, Function]} always ["list", noop]
 */
const noop = () => {};

export function useViewMode() {
  return ["list", noop];
}

export default useViewMode;
